import { Component, EventEmitter, Input } from '@angular/core';
import {
    DataLoaderResult,
    IDataLoaderResult,
    SQL_NOT_AVAILABLE,
} from 'src/app/services/data-loader/data-loader-result';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { IQueryContext } from 'src/app/services/query-context/models/IQueryContext';
import { QueryContextService } from 'src/app/services/query-context/query-context.service';
import {
    IDashboardItem,
    IDashboardItemFactory,
} from 'src/app/utils/dashboard-item';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import {
    IMultipleSelectDataLoaderResult,
    SelectMode,
} from '../../../../../components/multiple-select/multiple-select.component';

export interface IFilterCategoryDashboardItem extends IDashboardItem {
    datasourceColumnId: DatasourceColumnId;
    excludeMode: boolean;
    composeData: (
        a: any[],
        b?: IQueryContext
    ) => IMultipleSelectDataLoaderResult['data'];
    splitable: boolean;
    selectMode: SelectMode;
    showQuickSelectionButtons: boolean;
}

@Component({
    selector: 'app-category-filter-dashboard-item',
    templateUrl: './category-filter-dashboard-item.component.html',
    styleUrls: ['./category-filter-dashboard-item.component.scss'],
})
export class FilterCategoryDashboardItemComponent {
    @Input()
    dashboardItemFactory!: IDashboardItemFactory; // IFactory<IFilterCategoryDashboardItem>;
    dashboardItem!: IFilterCategoryDashboardItem;

    @Input()
    dataLoaderEmitter!: EventEmitter<IDataLoaderResult>;

    dataLoaderResult: IMultipleSelectDataLoaderResult =
        DataLoaderResult.getLoading<IMultipleSelectDataLoaderResult['data']>(
            new Array<{ value: any; label: string }>(),
            QueryContextService.EMPTY
        );

    private dataLoaderSubscriber = (dataLoaderResult: IDataLoaderResult) => {
        // this.logger.debug(
        //     `[CategoryFilterDashboardItemComponent][${this.dashboardItem.instanceId}] Got dataLoaderResult`,
        //     [dataLoaderResult]
        // );

        if (dataLoaderResult.isLoading) {
        } else {
            if (dataLoaderResult.status == 'error') {
            } else {
            }
        }
        if (dataLoaderResult.sqlAndJsProcessing != SQL_NOT_AVAILABLE) {
        }

        if (dataLoaderResult.status == 'ok') {
            const data = this.dashboardItem.composeData(
                dataLoaderResult.data,
                dataLoaderResult.queryContext
            );
            this.dataLoaderResult = {
                ...dataLoaderResult,
                data,
            };
            // console.log(this.dataLoaderResult);
        }
    };
    constructor(private logger: LoggerService) {
        // this.query = query;
    }

    ngOnInit(): void {
        this.dashboardItem =
            this.dashboardItemFactory.create() as IFilterCategoryDashboardItem;
        this.dataLoaderEmitter.subscribe(this.dataLoaderSubscriber);
    }

    public isExcludeMode(): boolean {
        return this.dashboardItem.excludeMode;
    }

    public isSplitable(): boolean {
        return this.dashboardItem.splitable;
    }

    public isQuickSelectionButtons(): boolean {
        return this.dashboardItem.showQuickSelectionButtons;
    }
}
